import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, Box, Grid, TextField, Paper, Typography, Button, Snackbar  } from '@material-ui/core';
import { Link as RouterLink, useHistory } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux';
import {
    setTestament,
    clearTestament,
} from '../stores/testament'

import MenuList from './MenuList' // メニュー
import GuideHalf from './GuideHalf' // ガイド

import FlowTitle from './FlowTitle' // フロータイトル
import FlowItem from './FlowItem' // フローアイテム
import FlowArrow from './FlowArrow' // フローアロー
import FlowCaution from './FlowCaution' // フロー注意

import PageExplanation from './PageExplanation' // ページ説明

import PageStep from './PageStep' // ステップ
import PersonStep from './PersonStep' // 個人情報ステップ

const useStyles = makeStyles((theme) => ({
    menu: {
        marginTop: '1rem',
    },
    explanation: {
        marginTop: '1rem',
        padding: '.5rem'
    },
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    },
}));

// 遺言者
function Testament(){
    const dispatch = useDispatch();

    const history = useHistory();

    const testament = useSelector(state => state.testament);

    const igonFlag = useSelector(state => state.igon.igonFlag);

    const handleAuthor = () => {
        if(igonFlag){
            history.push('/authorwill');
        }else{
            history.push('/author');
        }
    }

    const [alert, setAlert] = useState(false);
    const [error, setError] = useState(null);

    const alertClose = () => {
        setAlert(false);
    }

    const handleTestament = (event) => {
        const testamentName = document.getElementById('testament_name').value;
        const testamentAge = document.getElementById('testament_age').value;
        const testamentAddress = document.getElementById('testament_address').value;
        const testamentDate = document.getElementById('testament_date').value;

        if(testamentName == ''){
            checkName(true);
            nameHelper('お名前は必ずご入力くさだい。');
            setError('エラーが発生しました。お名前は必ずご入力くさだい。');
            setAlert(true);
            return;
        }else if(testamentAge == ''){
            checkAge(true);
            ageHelper('ご年齢は必ずご入力くさだい。');
            setError('エラーが発生しました。ご年齢は必ずご入力くさだい。');
            setAlert(true);
            return;
        }else if(testamentAddress == ''){
            checkAddress(true);
            addressHelper('ご住所は必ずご入力くさだい。');
            setError('エラーが発生しました。ご住所は必ずご入力くさだい。');
            setAlert(true);
            return;
        }else if(testamentDate == ''){
            checkDate(true);
            dateHelper('遺言書作成年月日は必ずご入力くさだい。');
            setError('エラーが発生しました。遺言書作成年月日は必ずご入力くさだい。');
            setAlert(true);
            return;
        }else{
            document.getElementById('testament_name').value = '';
            document.getElementById('testament_age').value = '';
            document.getElementById('testament_address').value = '';
            document.getElementById('testament_date').value = '';

            setNameValue(null);
            setAgeValue(null);
            setAddressValue(null);
            setDateValue(null);

            const testament = {
                name: testamentName,
                age: testamentAge,
                address: testamentAddress,
                date: testamentDate
            };

            dispatch(setTestament(testament));

            history.push('/heiress');
        }
    }

    const [nameValue, setNameValue] = useState(testament.name);
    const [ageValue, setAgeValue] = useState(testament.age);
    const [addressValue, setAddressValue] = useState(testament.address);
    const [dateValue, setDateValue] = useState(testament.date);

    const handleTestamentEdit = (index, event) => {
        const testamentEdit = testament;

        setNameValue(testamentEdit.name);
        setAgeValue(testamentEdit.age);
        setAddressValue(testamentEdit.address);
        setDateValue(testamentEdit.date);

        dispatch(clearTestament(index))
    }

    const handleTestamentDelete = (index, event) => {
        dispatch(clearTestament())
    }

    const [nameHelperText, nameHelper] = useState('必須');
    const [ageHelperText, ageHelper] = useState('必須');
    const [addressHelperText, addressHelper] = useState('必須');
    const [dateHelperText, dateHelper] = useState('必須');

    const [nameValidate, checkName] = useState(false);
    const handleName = (event) => {
        if(event.target.value){
            checkName(false);
            nameHelper('必須');
            setNameValue(event.target.value);
        }else{
            checkName(true);
            nameHelper('お名前は必ずご入力くさだい。');
            setNameValue(null);
        }
    }

    const [ageValidate, checkAge] = useState(false);
    const handleAge = (event) => {
        if(event.target.value){
            checkAge(false);
            ageHelper('必須');
            setAgeValue(event.target.value);
        }else{
            checkAge(true);
            ageHelper('ご年齢は必ずご入力くさだい。');
            setAgeValue(null);
        }
    }

    const [addressValidate, checkAddress] = useState(false);
    const handleAddress = (event) => {
        if(event.target.value){
            checkAddress(false);
            addressHelper('必須');
            setAddressValue(event.target.value);
        }else{
            checkAddress(true);
            addressHelper('ご住所は必ずご入力くさだい。');
            setAddressValue(null);
        }
    }

    const [dateValidate, checkDate] = useState(false);
    const handleDate = (event) => {
        console.log(event);
        if(event.target.value){
            checkDate(false);
            dateHelper('必須');
            setDateValue(event.target.value);
        }else{
            checkDate(true);
            dateHelper('遺言書作成年月日は必ずご入力くさだい。');
            setDateValue(null);
        }
    }

    const classes = useStyles();

    return(
        <Container>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <PageExplanation pageName="遺言者登録" firstItemName="遺言者" igonFlag={igonFlag}/>

                    <PageStep activeStep={0}/>

                    <PersonStep activeStep={1}/>

                    <MenuList pageName="遺言者登録" />

                    <TextField
                        id="testament_name"
                        name="testament_name"
                        label="遺言者(被相続人)"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="遺言者をご入力ください。"
                        helperText={nameHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleName}
                        onChange={handleName}
                        error={nameValidate}
                        value={nameValue}
                    />
                    <TextField
                        id="testament_age"
                        name="testament_age"
                        label="年齢"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="ご年齢をご入力ください。"
                        helperText={ageHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleAge}
                        onChange={handleAge}
                        error={ageValidate}
                        value={ageValue}
                    />
                    <TextField
                        id="testament_address"
                        name="testament_address"
                        label="住所"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="ご住所をご入力ください。"
                        helperText={addressHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleAddress}
                        onChange={handleAddress}
                        error={addressValidate}
                        value={addressValue}
                    />
                    <TextField
                        id="testament_date"
                        name="testament_date"
                        label="遺言書作成年月日"
                        style={{ margin: 8 }}
                        className={classes.required}
                        fullWidth
                        helperText={dateHelperText}
                        type="date"
                        value={dateValue}
                        onKeyUp={handleDate}
                        onChange={handleDate}
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={dateValidate}
                    />

                    <Paper className={classes.explanation}>
                        <Typography>
                            遺言者の情報をご入力ください。
                            入力されたら相続人の入力に進んでください。
                        </Typography>
                    </Paper>

                    <Box>
                        <Grid container className={classes.menu} spacing={2}>
                            <Grid item xs={6}>
                                <Button variant="contained" color="primary" fullWidth onClick={handleTestament}>相続人の入力に移る</Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button variant="contained" color="default" fullWidth onClick={handleAuthor}>戻る</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <FlowTitle title="自筆証書遺言の作成の流れをご説明します。" />
                    <FlowItem image="img/icon_person.png" contents="①遺言者情報を登録<br>まず、遺言者の情報をご登録ください。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_memo.png" contents="②相続人の登録は「相続人の入力に移る」を<br>クリックし、相続人全ての方を入力ください。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_mouse.png" contents="②相続人の登録は「相続人の入力に移る」を<br>クリックし、相続人全ての方を入力ください。" />
                    <FlowCaution/>
                    <GuideHalf pageName="遺言者登録"/>
                </Grid>
            </Grid>

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={alert} autoHideDuration={3000} onClose={alertClose} message={error}/>
        </Container>
    );
}

export default Testament
